import React, { useEffect, useState } from "react";
import { useParams, Navigate, Link } from "react-router-dom";
import { AtSign } from "lucide-react";
import api from "@/lib/api";
import { Loading, EmptyState } from "@/components/common/Loading";
import { Button } from "@/components/ui/button";

/** Resolves /@handle to the correct personal/business/capital profile (slug-independent)
 * and redirects to the canonical URL. Renders a friendly fallback for unclaimed handles. */
export default function HandleResolver() {
  const { athandle } = useParams();
  const isHandle = !!athandle && athandle.startsWith("@");
  const [target, setTarget] = useState(undefined);

  useEffect(() => {
    if (!isHandle) { setTarget(null); return; }
    let ok = true;
    api.get(`/handles/resolve/${encodeURIComponent(athandle.slice(1))}`)
      .then(({ data }) => { if (ok) setTarget(data.canonical_url || null); })
      .catch(() => { if (ok) setTarget(null); });
    return () => { ok = false; };
  }, [athandle, isHandle]);

  if (isHandle && target === undefined) return <div className="py-24"><Loading /></div>;
  if (target) return <Navigate to={target} replace />;
  return (
    <div className="mx-auto max-w-2xl px-4 py-24" data-testid="handle-not-found">
      <EmptyState
        icon={AtSign}
        title={isHandle ? `${athandle} isn't claimed` : "Page not found"}
        description={isHandle ? "No profile uses this handle yet." : "We couldn't find the page you're looking for."}
        action={<Link to="/people"><Button>Browse members</Button></Link>}
      />
    </div>
  );
}
